export const DEFAULT_ROSTER_PAGE_SIZE = 20;

export const TRACK_SOCIALS_ORDER = ['spotify', 'apple', 'amazon', 'youtube'];

export const ERROR_FORM_LINK =
  'https://docs.google.com/forms/d/e/1FAIpQLSefQ1_QjxKfrYjKxX0fDwgOr8iwGy8ZH0wIAO6Gz6HlU0YvJw/viewform';

export const ARTIST_ENTITY_TYPES = [
  'Artist',
  'Songwriter',
  'Crossover',
] as const;

export const COMPETENCY_TYPES = [
  'PERFORMING_ARTIST',
  'SONGWRITER',
  'CONTRIBUTING_ARTIST',
  'CONTRIBUTING_SONGWRITER',
] as const;

export const ROSTER_PERMISSION_TYPES = [
  'PARTY_CONTACT_INFO.VIEW',
  'PARTY_CONTACT_INFO.EXPORT',
] as const;
